import {
  mdiAccountMultiple,
  mdiDialpad,
  mdiPackageVariant,
  mdiEmoticonHappyOutline,
  mdiCupOutline,
  mdiBarcode,
} from '@mdi/js';

export default {
  data() {
    return {
      menuItems: [
        // eslint-disable-next-line max-len
        { name: 'menu.adminBrandCode', pathName: 'processing-ListBrandingCode', icon: mdiBarcode },
        { name: 'menu.adminCanSize', pathName: 'processing-ListCanSize', icon: mdiCupOutline },
        { name: 'menu.adminListStockType', pathName: 'processing-ListStockType', icon: mdiPackageVariant },
        { name: 'menu.adminListUserPin', pathName: 'processing-ListUserPin', icon: mdiDialpad },
        { name: 'menu.adminFeedbackItems', pathName: 'admin-FeedbackItems', icon: mdiEmoticonHappyOutline },
        { name: 'menu.adminUserManagement', pathName: 'admin-UserManagementHome', icon: mdiAccountMultiple },
      ],
    };
  },
};
